import "./NotReportView.css";

const NotReportViewData = ( {title, Icon} ) => {
	/*Los props van en Titulo y Icono*/
	return (
		<div className='boxnotdata'>
			<div>
				<Icon className='iconnotdataform' />
			</div>
			<div className='boxtittlenotdataform'>
				<p className='tittlenotdata'>{title}</p>
			</div>
			<div className='boxexplainnotdata'>
				<p className='explainotdata'>
					Ups, parece que no hay información disponible.
				</p>
			</div>

			<div className='boxexplainnotdata'>
				<p className='explainotdata'>
					Te pido por favor, que indiques otro Cuit o DNI.
				</p>
			</div>
		</div>
	);
};

export default NotReportViewData;